import React from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import { colorOptions } from '../models/configuration-models';
import { Option } from '../models/table-models';
import { colorSelectStyles } from '../styles/selectStyles';

export const ColorSelect = ({ colorValue, updateValue }: { colorValue: string; updateValue: (e?: string) => void }) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });

    const findColor = (colorValue: string) => {
        return colorOptions.find(({ value }) => value === colorValue);
    };

    return (
        <Select
            options={colorOptions}
            value={findColor(colorValue)}
            styles={colorSelectStyles}
            getOptionValue={(option) => option.value}
            getOptionLabel={(option) => t(option.name)}
            onChange={(newValue?: Option | null) => updateValue(newValue?.value)}
        ></Select>
    );
};
